module.exports = __webpack_public_path__ + "img/box3.cad28479.png";